import React from 'react';

import { ReactComponent as LoadingIcon } from 'assets/loading.svg';
import clsx from 'clsx';
import { Typography } from 'kill-components';

import useStyles from './Button.styles';

const Button = (props) => {
  const {
    className,
    children,
    onClick,
    isLoading,
    disabled
  } = props;

  const { classes } = useStyles({ isLoading });

  return (
    <button
      className={clsx(classes.root, { [classes.isLoading]: isLoading }, className)}
      disabled={disabled || isLoading}
      type="button"
      onClick={onClick}
    >
      {isLoading && <LoadingIcon className={classes.loadingIcon} />}
      <Typography component="span" fontWeight="bold" variant="body2">{children}</Typography>
    </button>
  );
};

export default Button;
